(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-testimonials"] && !Shopify.designMode) return;
  try {
    
  class SectionTestimonials extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.initSwiper();
    }

    initSwiper() {
      const swiperContainer = this.querySelector('.swiper-testimonials');
      if (!swiperContainer) return;

      new Swiper(swiperContainer, {
        slidesPerView: 1.2,
        centeredSlides: false,
        spaceBetween: 16,
        loop: true,
        speed: 800,
        navigation: {
          nextEl: this.querySelector('.custom-slider-next'),
          prevEl: this.querySelector('.custom-slider-prev')
        },
        breakpoints: {
          768: {
            slidesPerView: 1.5,
            spaceBetween: 40,
            centeredSlides: true,
          },
          1200: {
            slidesPerView: 1.5,
            spaceBetween: 86,
            centeredSlides: true,
          }
        }
      });
    }
  }
  customElements.define('section-testimonials', SectionTestimonials);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
